/*
 * History.jsx 21.08.18
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import format from 'date-fns/format';
import HistoryIcon from '@material-ui/icons/History';


const dateFormat = 'DD.MM.YYYY';
const timeFormat = 'HH:mm';


const styles = theme => ({

    goalCreatedByLabel: {
        gridArea: 'goalCreatedByLabel',
        padding: '0 1rem',
        fontSize: '0.8em',
        color: theme.palette.text.secondary
    },
    goalCreatedBy: {
        gridArea: 'goalCreatedBy',

        padding: '0 1rem 1.5rem 1rem',

        fontWeight: '500',
        fontSize: '0.8em',
        color: theme.palette.text.secondary
    },

    boldName: {
        fontWeight: 'bold'
    },

    history: {
        gridArea: 'history',
        position: 'relative',
        height: 'auto',
        backgroundColor: '#F8F8FB'
    },

    historyIcon: {
        width: '24px',
        margin: '1rem auto'
    },
    author: {
        marginBottom: 10
    },
    date: {
        marginBottom: 20
    },
    center180: {
        width: '155px',
        margin: '0 auto'
    },
    modifierBlock: {
        marginTop: 30
    },
    box: {
        position: 'absolute',
        top: 15,
        left: '50%',
        transform: 'translateX(-50%)'
    }

});

/**
 * Komponente zur Darstellung der Änderungshistorie eines Ziels, einer Umsetzung oder eines Schrittes
 */
class History extends React.Component {
    render() {
        const {classes, history} = this.props;

        const EditorStamp = () => {

            if (history.erstelltAm !== history.geaendertAm) {
                return (
                    <div className={classes.modifierBlock}>
                        <div className={classes.author}>
                            <Typography className={classes.goalCreatedByLabel} noWrap>Zuletzt geändert von:</Typography>
                            <Typography classes={{root: `${classes.goalCreatedByLabel} ${classes.boldName}` }} noWrap>{history.geaendertVon}</Typography>
                        </div>
                        <div className={classes.date}>
                            <Typography className={classes.goalCreatedByLabel} noWrap>Zuletzt geändert am:</Typography>
                            <Typography classes={{root: `${classes.goalCreatedByLabel} ${classes.boldName}` }} noWrap>{format(history.geaendertAm, dateFormat)}</Typography>
                            <Typography classes={{root: `${classes.goalCreatedByLabel} ${classes.boldName}` }} noWrap>{format(history.geaendertAm, timeFormat)} Uhr</Typography>
                        </div>
                    </div>

                );
            }

            return null;

        };


        return (
            <div className={classes.history}>

                <div className={classes.box}>

                    <div className={classes.historyIcon}>
                        <HistoryIcon color="primary" />
                    </div>
                    <div className={classes.center180}>

                        <div className={classes.author}>
                            <Typography className={classes.goalCreatedByLabel} noWrap>Erstellt von:</Typography>
                            <Typography classes={{root: `${classes.goalCreatedByLabel} ${classes.boldName}` }} noWrap>{history.emaw ? 'eM@w' : history.erstelltVon}</Typography>
                        </div>

                        <EditorStamp />

                    </div>

                </div>

            </div>
        );
    }
}
export default withStyles(styles)(History);



// WEBPACK FOOTER //
// ./src/de/ergovia/components/detail/History.jsx